import { useAppDispatch, useAppSelector } from "../../../../hooks/store-hooks";
import { useDeleteReactionMutation } from "../../../../store/api/homeApi";
import { closeModal } from "../../../../store/slices/modalSlice";
import Button from "../../../common/button";
import Modal from "../../../common/modals";
import { toastError, toastSuccess } from "../../../toast";
import { ReactionData } from "./report-comment";

interface DeleteReactionProps {
  onCommentDeleted?: (
    postId: string,
    commentId: string,
    reactionType: string,
  ) => void;
}

const DeleteReaction: React.FC<DeleteReactionProps> = ({
  onCommentDeleted,
}) => {
  const dispatch = useAppDispatch();
  const [deleteReaction, { isLoading }] = useDeleteReactionMutation();
  const { modalData } = useAppSelector(
    (state) => state.modal || { modalData: {} },
  );

  const reactionData = modalData as ReactionData;
  const handleDelete = async () => {
    try {
      if (!reactionData?.entityId) {
        toastError({ message: "Invalid comment ID" });
        return;
      }

      const response = await deleteReaction(reactionData.entityId).unwrap();
      if (response?.success) {
        toastSuccess({
          message: response.data?.message || "Comment deleted successfully",
        });
        if (
          onCommentDeleted &&
          reactionData.postId &&
          reactionData.entityId &&
          reactionData.reactionType
        ) {
          onCommentDeleted(
            reactionData.postId,
            reactionData.entityId,
            reactionData.reactionType,
          );
        }
      } else {
        toastError({
          message: response.error?.message || "Failed to delete comment",
        });
      }
    } catch (error) {
      console.log(error);
      toastError({ message: "Something went wrong" });
    }
    dispatch(closeModal());
  };

  const isReply = reactionData?.reactionType === "reply";

  return (
    <Modal size="small" isOpen={true}>
      <div className="bg-white rounded-xl mx-3">
        <div className=" w-full flex flex-col items-center gap-4 border-b  p-4 pt-10">
          <div className="text-primary-900 text-[28px] font-bold leading-8 tracking-tight">
            {isReply ? "Delete Reply" : "Delete Comment"}
          </div>
          <div className="text-center text-primary-900 text-base font-normal leading-5">
            Are you sure you want to delete this {isReply ? "reply" : "comment"}
            ? Once deleted it cannot be brought back.
          </div>
          <img src="/assets/delete-post.png" className="w-44 h-44" alt=""></img>
        </div>
        <div className="w-full flex gap-2 justify-end py-4">
          <Button
            variant="secondary"
            onClick={() => {
              dispatch(closeModal());
            }}
          >
            Cancel
          </Button>
          <Button
            isSubmitting={isLoading}
            variant="danger"
            onClick={() => {
              handleDelete();
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteReaction;
